import { useMemo, useRef } from "react";

import { formatCurrency } from "../../Utils/helpers";
import { getActivityDateOrStatus } from "../../Utils/api-data-transforms";
import useDialogFocusManagement from "../../Utils/use-dialog-focus";

export default function BankingPopupActivity({ open, onClose, activitiesData }) {
  const activityList = useMemo(
    () => activitiesData?.data?.data?.activities ?? [],
    [activitiesData?.data?.data?.activities],
  );

  const dialogRef = useRef(null);
  useDialogFocusManagement({
    isOpen: !!open,
    dialogRef,
    closeSelector: ".bp-close",
    onEscape: onClose,
  });

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (!open) return null;

  return (
    <div className={`bp-overlay${open ? " open" : ""}`} onClick={handleBackdropClick}>
      <div ref={dialogRef} className="bp-card" role="dialog" aria-modal="true" aria-labelledby="bp-card-title">
        <div className="bp-header">
          <h3 id="bp-card-title">All Activity</h3>
          <button className="bp-close" onClick={onClose} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="#8B8FA3" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {activityList.length === 0 ? (
          <div className="bp-body">
            <span className="bp-empty">No activity yet</span>
          </div>
        ) : (
          activityList.map((activity) => {
            const kind = activity.direction === "Credit" ? "credit" : "debit";
            return (
              <div key={activity._id} className="bp-tx-row">
                <div className={`bp-tx-icon ${kind}`}>
                  {kind === "credit" ? (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 4v6m0 0l2.5-2.5M7 10L4.5 7.5" stroke="#54FF99" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M7 10V4m0 0L4.5 6.5M7 4l2.5 2.5" stroke="#E85454" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
                <div className="bp-tx-text">
                  <span className={`bp-tx-type ${kind}`}>{activity.category}</span>
                  <span className="bp-tx-date">{getActivityDateOrStatus(activity)}</span>
                </div>
                <div className="bp-tx-amounts">
                  <span className={`bp-tx-amount ${kind}`}>
                    {kind === "credit" ? "+" : "-"}
                    {formatCurrency(Math.abs(activity.amount))}
                  </span>
                  <span className="bp-tx-balance">{formatCurrency(activity.balance)}</span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
